export default {
      id: "no-image-usage",
      viewBox: "0 0 34 26",
      url: __webpack_public_path__ + "img/icons.svg#no-image",
      toString: function () {
        return this.url;
      }
    }